import React from 'react';
import { SuportLoginDataContext } from './context';
import { c42Jwt, useOnSubmitLoginSuccess } from '../auth/hooks';
import { useHistory } from 'react-router';
import { LOGIN_INDEX } from '../../../constants/routes';
import { useRoutingData } from '../routing/hooks';

export const useSupportLoginData = () => React.useContext(SuportLoginDataContext).supportLoginData;

export const useSetSupportLoginData = () => React.useContext(SuportLoginDataContext).setSupportLoginData;

export const useLoadEmployeeInfo = () => {
  const history = useHistory();
  const setSupportLoginData = useSetSupportLoginData();

  return async () => {
    setSupportLoginData((current) => ({
      ...current,
      isFetchingEmployeeInfo: true,
      isEmployeeInfoError: false,
    }));
    try {
      const employeeInfo = await c42Jwt.getEmployeeInfo();
      setSupportLoginData((current) => ({
        ...current,
        employeeInfo: employeeInfo,
        isFetchingEmployeeInfo: false,
        isEmployeeInfoError: false,
      }));
    } catch (e) {
      if (e?.status === 401 || e?.status === 403) {
        history.push(LOGIN_INDEX);
      } else {
        setSupportLoginData((current) => ({
          ...current,
          isFetchingEmployeeInfo: false,
          isEmployeeInfoError: true,
        }));
      }
    }
  };
};

export const useLoadTenantName = () => {
  const history = useHistory();
  const setSupportLoginData = useSetSupportLoginData();

  return async (tenantId: string) => {
    setSupportLoginData((current) => ({
      ...current,
      isFetchingTenantName: true,
      isTenantNameError: false,
    }));
    try {
      const tenantName = await c42Jwt.getTenantName({ tenantId });
      setSupportLoginData((current) => ({
        ...current,
        tenantName: tenantName,
        isFetchingTenantName: false,
        isTenantNameError: false,
      }));
    } catch (e) {
      if (e?.status === 401 || e?.status === 403) {
        history.push(LOGIN_INDEX);
      } else {
        setSupportLoginData((current) => ({
          ...current,
          isFetchingTenantName: false,
          isTenantNameError: true,
        }));
      }
    }
  };
};

export const useSubmitForm = () => {
  const history = useHistory();
  const { accessType, tenantId } = useSupportLoginData();
  const { redirectParam } = useRoutingData();
  const setSupportLoginData = useSetSupportLoginData();
  const onSubmitLoginSuccess = useOnSubmitLoginSuccess();

  return async () => {
    setSupportLoginData((current) => ({
      ...current,
      isFetchingJwt: true,
      isJwtError: false,
    }));
    try {
      await c42Jwt.loginSupportUser({
        accessType,
        tenantId,
      });
      onSubmitLoginSuccess(redirectParam);
    } catch (e) {
      if (e?.status === 401 || e?.status === 403) {
        history.push(LOGIN_INDEX);
      } else {
        setSupportLoginData((current) => ({
          ...current,
          isFetchingJwt: false,
          isJwtError: true,
        }));
      }
    }
  };
};
